export default __webpack_public_path__ + "static/media/project.b64c83f3.svg";